import type { WebUser } from "@/types/WebUser";
import { AvatarIcon } from "@roman/shared/components/Icons/AvatarIcon";

export const Avatar = ({ user }: { user: WebUser }) => {
  return (
    <>
      {user.photoUrl ? (
        <div className="w-9 h-9">
          <img
            src={user.photoUrl || "/assets/player-shirt.png"}
            alt={user.name.substring(0, 1)}
            className="rounded-full"
            referrerPolicy="no-referrer"
          />
        </div>
      ) : (
        <div className="flex items-center justify-center rounded-full w-9 h-9 bg-secondary">
          <AvatarIcon />
        </div>
      )}
    </>
  );
};
